module.exports = __webpack_public_path__ + "img/rectangle-table-10.1a44245a.png";